import {push} from 'react-router-redux/lib/actions';
import {PropTypes} from 'react';

export const ListProps = {
  loading: PropTypes.bool.isRequired,
  loadingMore: PropTypes.bool,
  hasMore: PropTypes.bool,
  list: PropTypes.array
};

export function getListState({ loading, loadingMore, hasMore, list, items, error, loadingItem }) {
  return {
    loadingItem,
    loading,
    loadingMore,
    hasMore,
    error,
    items: list.map(id => items[id])
  };
}

export function getListActions(crudActions, dispatch) {
  return {
    fetchItem: () => dispatch(crudActions.fetch()),
    fetch: (query) => dispatch(crudActions.fetchList(query)),
    fetchMore: () => dispatch(crudActions.fetchListMore())
  };
}

export function getNavigacion({newRoute, editRoute}, dispatch) {
  return {
    edit: (id) => dispatch(push(editRoute.replace(':id', id))),
    add: () => dispatch(push(newRoute))
  };
}



// WEBPACK FOOTER //
// ./src/utilites/helpers/crudListHelper.js